// Friend links require confirmation; old group links no longer create a streak setup flow.
import React, { useEffect, useState } from 'react';
import { useRoute, type RouteProp } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';
import { Body, Button, Screen, Section } from '../components/ui';
import * as social from '../platform/social';
import { useAccount } from '../store/account';
import { useSocial } from '../store/social';
import { useNav, type AllParams } from '../navigation';
import SocialError from '../components/SocialError';

type Preview = Awaited<ReturnType<typeof social.joinPreview>>;
export default function JoinScreen() {
  const { t } = useTranslation(), nav = useNav();
  const code = useRoute<RouteProp<AllParams, 'Join'>>().params?.code ?? '';
  const signedIn = useAccount(s => !!s.user);
  const { busy, run } = useSocial();
  const [preview, setPreview] = useState<Preview | null>(null);
  useEffect(() => {
    let active = true;
    if (signedIn && code) run(() => social.joinPreview(code)).then(value => { if (active) setPreview(value); });
    return () => { active = false; };
  }, [signedIn, code, run]);
  if (!signedIn) return <Screen><Button label={t('account.title')} icon="user" onPress={() => nav.navigate('Account')} /></Screen>;
  return <Screen><Section>
    <SocialError />
    {preview?.kind === 'friend' ? <>
      <Body>{preview.self ? t('friends.ownLink') : t('friends.joinWho', { name: preview.name ?? '' })}</Body>
      <Button label={preview.member ? t('streaks.open') : t('friends.accept')} icon="buddies" disabled={preview.self || busy} loading={busy} onPress={async () => {
        if (preview.member || await run(() => social.join(code))) nav.navigate('Tabs', { screen: 'SocialTab' });
      }} />
    </> : preview ? <>
      <Body>{t('relay.legacyLink')}</Body>
      <Button label={t('streaks.open')} icon="buddies" onPress={() => nav.navigate('Tabs', { screen: 'SocialTab' })} />
    </> : null}
  </Section></Screen>;
}
